module.exports = __webpack_public_path__ + "img/hanhua2.4606742d.png";